import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination, Navigation, Autoplay, EffectFade } from "swiper/modules"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import "swiper/css/autoplay"
import "swiper/css/effect-fade"
import services1 from "../assets/services1.jpeg"
import services2 from "../assets/services2.jpeg"
import services3 from "../assets/services3.jpeg"
import services4 from "../assets/services4.jpeg"
import services5 from "../assets/services5.jpeg"
import services6 from "../assets/services6.jpeg"
import { Link } from "react-router-dom"

export const Services = () => {
  return (
    <section className="min-h-screen w-full bg-gray-50 flex flex-col justify-center items-center py-24">
      <div className="container mx-auto px-4 sm:px-6">
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-800 text-center mb-8 md:mb-12 animate-fade-in">
          Our Comprehensive Services: Building Your Dream Home, Step by Step
        </h2>

        {/* Introduction */}
        <div className="mb-8 gap-5 flex flex-col items-center animate-slide-in-right">
          <p className="text-gray-700 leading-relaxed text-base md:text-lg text-center">
            At Modular Home, we offer a full range of services to guide you
            through every stage of the modular home building process, from
            initial design to final installation. Our experienced team is
            dedicated to providing exceptional service and ensuring a seamless
            and stress-free experience.
          </p>
        </div>

        {/* Swiper Carousel */}
        <div className="w-full max-w-4xl mx-auto aspect-square animate-slide-in-left">
          <Swiper
            style={{
              "--swiper-pagination-color": "#4CAF50",
              "--swiper-navigation-color": "#4CAF50",
            }}
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            effect="fade"
            speed={1000}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            modules={[Pagination, Navigation, Autoplay, EffectFade]}
            className="w-full h-full"
          >
            {/* Step 1: Consultation and Design */}
            <SwiperSlide>
              <div className="relative h-full">
                <img
                  src={services1}
                  alt="Architect discussing plans with a client."
                  className="w-full h-full object-cover rounded-2xl"
                />
                <div className="absolute inset-0 flex flex-col justify-between rounded-2xl">
                  <h3 className="text-xl md:text-2xl font-semibold text-white bg-black bg-opacity-50 p-4 md:p-6 rounded-t-2xl">
                    1. Consultation and Design
                  </h3>
                  <p className="text-sm md:text-base text-white bg-black bg-opacity-50 p-4 md:p-6 rounded-b-2xl">
                    We begin with a thorough consultation to understand your
                    needs, preferences, and budget. Our expert designers will
                    work closely with you to create a custom modular home design
                    that perfectly reflects your vision.
                  </p>
                </div>
              </div>
            </SwiperSlide>

            {/* Step 2: Permitting and Approvals */}
            <SwiperSlide>
              <div className="relative h-full">
                <img
                  src={services2}
                  alt="Architectural blueprints and building permits."
                  className="w-full h-full object-cover rounded-2xl"
                />
                <div className="absolute inset-0 flex flex-col justify-between rounded-2xl">
                  <h3 className="text-xl md:text-2xl font-semibold text-white bg-black bg-opacity-50 p-4 md:p-6 rounded-t-2xl">
                    2. Permitting and Approvals
                  </h3>
                  <p className="text-sm md:text-base text-white bg-black bg-opacity-50 p-4 md:p-6 rounded-b-2xl">
                    Navigating the permitting process can be complex, but our
                    team will handle all the necessary paperwork and approvals.
                    We have extensive experience working with local building
                    codes and regulations.
                  </p>
                </div>
              </div>
            </SwiperSlide>

            {/* Step 3: Module Construction */}
            <SwiperSlide>
              <div className="relative h-full">
                <img
                  src={services3}
                  alt="Modular home modules being constructed in a controlled factory environment."
                  className="w-full h-full object-cover rounded-2xl"
                />
                <div className="absolute inset-0 flex flex-col justify-between rounded-2xl">
                  <h3 className="text-xl md:text-2xl font-semibold text-white bg-black bg-opacity-50 p-4 md:p-6 rounded-t-2xl">
                    3. Module Construction
                  </h3>
                  <p className="text-sm md:text-base text-white bg-black bg-opacity-50 p-4 md:p-6 rounded-b-2xl">
                    Your modular home modules will be constructed in our
                    state-of-the-art factory, using high-quality materials and
                    advanced manufacturing techniques.
                  </p>
                </div>
              </div>
            </SwiperSlide>

            {/* Step 4: Site Preparation */}
            <SwiperSlide>
              <div className="relative h-full">
                <img
                  src={services4}
                  alt="Construction crew preparing the building site for modular home installation."
                  className="w-full h-full object-cover rounded-2xl"
                />
                <div className="absolute inset-0 flex flex-col justify-between rounded-2xl">
                  <h3 className="text-xl md:text-2xl font-semibold text-white bg-black bg-opacity-50 p-4 md:p-6 rounded-t-2xl">
                    4. Site Preparation
                  </h3>
                  <p className="text-sm md:text-base text-white bg-black bg-opacity-50 p-4 md:p-6 rounded-b-2xl">
                    While your modules are being constructed, our team will
                    prepare your building site for installation. This includes
                    clearing the land, pouring the foundation, and installing
                    utilities.
                  </p>
                </div>
              </div>
            </SwiperSlide>

            {/* Step 5: Module Installation */}
            <SwiperSlide>
              <div className="relative h-full">
                <img
                  src={services5}
                  alt="Crane lifting a modular home module into place."
                  className="w-full h-full object-cover rounded-2xl"
                />
                <div className="absolute inset-0 flex flex-col justify-between rounded-2xl">
                  <h3 className="text-xl md:text-2xl font-semibold text-white bg-black bg-opacity-50 p-4 md:p-6 rounded-t-2xl">
                    5. Module Installation
                  </h3>
                  <p className="text-sm md:text-base text-white bg-black bg-opacity-50 p-4 md:p-6 rounded-b-2xl">
                    Once your site is prepared, your modular home modules will
                    be transported to the site and carefully installed by our
                    experienced crew.
                  </p>
                </div>
              </div>
            </SwiperSlide>

            {/* Step 6: Finishing Touches */}
            <SwiperSlide>
              <div className="relative h-full">
                <img
                  src={services6}
                  alt="Interior designer adding finishing touches to a modular home interior."
                  className="w-full h-full object-cover rounded-2xl"
                />
                <div className="absolute inset-0 flex flex-col justify-between rounded-2xl">
                  <h3 className="text-xl md:text-2xl font-semibold text-white bg-black bg-opacity-50 p-4 md:p-6 rounded-t-2xl">
                    6. Finishing Touches
                  </h3>
                  <p className="text-sm md:text-base text-white bg-black bg-opacity-50 p-4 md:p-6 rounded-b-2xl">
                    After the modules are installed, our team will complete the
                    finishing touches, including connecting utilities,
                    installing fixtures, and applying interior and exterior
                    finishes.
                  </p>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>

          {/* Buttons */}
          <div className="flex flex-col md:flex-row justify-between gap-4 py-5">
            <Link
              to="/offer"
              className="inline-block bg-green-800 text-white py-2 px-6 md:py-3 md:px-8 rounded-full hover:bg-green-600 font-semibold
              transition
              duration-300
              ease-in-out
              hover:-translate-y-1
              hover:scale-110
              text-sm md:text-base text-center"
            >
              Discover Your Possibilities
            </Link>
            <Link
              to="/contact"
              className="inline-block bg-green-800 text-white py-2 px-6 md:py-3 md:px-8 rounded-full hover:bg-green-600 font-semibold
              transition
              duration-300
              ease-in-out
              hover:-translate-y-1
              hover:scale-110
              text-sm md:text-base text-center"
            >
              Get a Free Consultation
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
